// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSFileTypeText/index.less
// module id = 777
// module chunks = 42